import React, {useEffect, useRef, useState} from 'react';
import axios, { AxiosRequestConfig } from "axios";
import { Image } from "primereact/image";
import { Button } from 'primereact/button';
import { DataScroller } from "primereact/datascroller";
import { useNavigate } from 'react-router-dom';
import { Checkbox } from 'primereact/checkbox';
import data from './Data.json';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { ProgressBar } from 'primereact/progressbar';
import { Skeleton } from 'primereact/skeleton';


const DemoGenerator = () => {
    const [showTableValues, setShowTableValues] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [tableValues, setTableValues] = useState([]);

    const categoryOptions = [
        {value: 'frozen pizza', label: 'Pizza'},
        {value: 'paper products', label: 'Paper Products'},
        {value: 'bread', label: 'Bread'},
        {value: 'hair care', label: 'Hair Care'}
    ]

    const checkboxBrand = {
        'premium': "Premium / Foodie",
        'organic': 'Organic / Natural',
        'core': 'Core',
        'value': 'Value'
    }

    const checkboxOutput = {
        'description': 'Descriptions',
        'bullets': 'Bullets',
        'social_media': 'Social Media',
        'instore': 'In-Store',
    }
    const checkboxEditing = {
        'grammar': 'Grammar',
        'regulatory': 'Regulatory'
    }

    const createInitialState = () => {
        const initialState = {};
        categoryOptions.map((cat) => (
            initialState[cat.value] = false
        ));
        Object.entries(checkboxBrand).map(([key, label]) => (
            initialState[key] = false
        ));
        Object.entries(checkboxOutput).map(([key, label]) => (
            initialState[key] = false
        ));
        Object.entries(checkboxEditing).map(([key, label]) => (
            initialState[key] = false
        ));
        return initialState;
    };

    const [checkedState, setCheckedState] = useState(createInitialState());
    const [displayedState, setDisplayedState] = useState(createInitialState());

    // Handler for checkbox changes
    const handleCheckboxClick = (event) => {
        const { id } = event.target;
        setCheckedState(prevState => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };

    const simulateProgress = () => {
        return new Promise((resolve) => {
            let _val = 0;
    
            const progressInterval = setInterval(() => {
                _val += 20;
    
                if (_val >= 100) {
                    _val = 100;
                    setValue(_val);
                    clearInterval(progressInterval);
                    resolve(null); // Resolve the promise when done
                } else {
                    setValue(_val);
                }
            }, 1000); // faster simulation, adjust as needed
        });
    };

    // Handler for form submission
    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission behavior
        setIsLoading(true)
        setShowTableValues(false);

        await simulateProgress();
        setTimeout(() => {
            setIsLoading(false);
            setShowTableValues(true);
            setDisplayedState(checkedState);
            const values = JSON.parse(JSON.stringify(dataBySelectedCommodity()));
            setTableValues(values);
        }, 500);
        setTimeout(() => {
            setValue(0)
        }, 1000);
    };

    // Handler for clearing the selection
    const handleClearSelection = () => {
        setCheckedState(createInitialState());
        setShowTableValues(false)
        console.log('Selection Cleared!');
    };

    const FormattedColumn = (label: string, field: string, show: boolean = true): JSX.Element =>
        show && 
        <Column
            className=" text-white border-x-2"
            field={field}
            headerClassName="text-white bg-purple-900"
            style={{ overflowWrap: 'break-word', whiteSpace: 'normal'}}
            bodyStyle={{ backgroundColor: 'transparent', alignContent: 'start', whiteSpace: 'pre-line', overflowWrap: 'break-word'}}
            // body={(data) => data.split('\n')}
            header={label} />

    const dataBySelectedCommodity = () => data.filter(product => checkedState[product.Commodity])
    
    const SkeletonGrid = () => {
        return (
            <div className="col-9 page-fade-in">
                <Skeleton className="mb-2 opacity-40" height='3rem' />
                {Array.from({ length: 4 }).map((_, rowIndex) => (
                    <div key={`row-${rowIndex}`} className="flex mb-3">
                        {Array.from({ length: 6 }).map((_, cellIndex) => (
                            <div key={`cell-${rowIndex}-${cellIndex}`} className="col-2">
                                <Skeleton className="mb-2 opacity-60"></Skeleton>
                                <Skeleton width="6rem" className="mb-2 opacity-40"></Skeleton>
                                <Skeleton width="5rem" className="mb-2 opacity-60"></Skeleton>
                                <Skeleton height="2rem" className="mb-2 opacity-40"></Skeleton>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div
            className='relative flex flex-column w-screen h-screen '
            style={{ background: "linear-gradient(135deg, #66328F 0%, #3c1e54 50%, #1e0f2a 100%)" }}
        >
            <div className="m-6 page-fade-in">
                <div className="row mb-6">
                    <a href='/haus/demo' style={{cursor: 'pointer'}}>
                        <h2 className='text-white'>ThinkhausAI Content Generator</h2>
                    </a>
                </div>
                <div className="grid">
                    <div className="col-3 px-3 demo-box-generate flex-column">
                        <form onSubmit={handleSubmit}>
                            <div className="flex flex-column justify-content-center text-center">
                                <div className="border-bottom-1 demo-separator mb-1 text-center" style={{}}>
                                    <h3>CATEGORIES</h3>
                                </div>
                                <div className="grid">
                                    {categoryOptions.map((option) => (
                                        <div className="col-6 flex flex-row">
                                            <div key={option.value} className="flex flex-wrap">
                                                <input
                                                    type="checkbox"
                                                    id={option.value}
                                                    name={option.label}
                                                    checked={checkedState[option.value]}
                                                    onChange={handleCheckboxClick}
                                                    className='demo-checkbox'
                                                />
                                                <label htmlFor={option.value} style={{ marginLeft: '4px', marginTop: '10px' }}>{option.label}</label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="border-bottom-1 demo-separator mb-1 text-center">
                                <h3>BRAND & VOICE</h3>
                            </div>
                            <div className="formgroup-inline grid">
                                {Object.entries(checkboxBrand).map(([key, label]) => (
                                    <div key={key} className="col-6 flex flex-wrap">
                                        <input
                                            type="checkbox"
                                            id={key}
                                            name={label}
                                            checked={checkedState[key]}
                                            onChange={handleCheckboxClick}
                                            className='demo-checkbox'
                                        />
                                        <label htmlFor={label} style={{ marginLeft: '4px', marginTop: '10px' }}>{label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="border-bottom-1 demo-separator mb-1 text-center">
                                <h3>OUTPUT</h3>
                            </div>
                            <div className="formgroup-inline grid">
                                {Object.entries(checkboxOutput).map(([key, label]) => (
                                    <div key={key} className="col-6 flex flex-wrap">
                                        <input
                                            type="checkbox"
                                            id={key}
                                            name={label}
                                            checked={checkedState[key]}
                                            onChange={handleCheckboxClick}
                                            className="demo-checkbox"
                                        />
                                        <label htmlFor={key} style={{ marginLeft: '4px', marginTop: '10px' }}>{label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="border-bottom-1 demo-separator mb-1 text-center">
                                <h3>EDITING</h3>
                            </div>
                            <div className="formgroup-inline my-3 flex flex-row justify-content-between m-1">
                                {Object.entries(checkboxEditing).map(([key, label]) => (
                                    <div key={key} className="field-checkbox" style={{ marginBottom: '8px' }}>
                                        <input
                                            type="checkbox"
                                            id={key}
                                            name={label}
                                            checked={checkedState[key]}
                                            onChange={handleCheckboxClick}
                                            className="demo-checkbox"
                                        />
                                        <label htmlFor={key} style={{ marginLeft: '8px' }}>{label}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="w-full flex justify-content-center">
                                <Button type="submit" className="demo-submit-button" label="GENERATE" />
                            </div>
                            <div className="flex justify-content-center my-3">
                                <a type="button" style={{cursor: 'pointer'}} onClick={handleClearSelection}>CLEAR SELECTIONS</a>
                            </div>
                        </form>
                    </div>
                    {isLoading &&
                        <div className="col-9">
                            {SkeletonGrid()}
                        </div>
                    }
                    {showTableValues &&
                        <DataTable
                            value={tableValues}
                            className="stickyTable page-fade-in col-9 border-bottom-2 text-white border-left-1 pl-3 text-xs"
                            tableStyle={{ backgroundColor: 'transparent' }}
                            scrollHeight='75vh'
                        >
                            {FormattedColumn('Product Title', 'Product_Title')}
                            {FormattedColumn('Core Description', 'Core_description', (displayedState['description'] && displayedState['core']))}
                            {FormattedColumn('Premium Description', 'Premium_description', (displayedState['description'] && displayedState['premium']))}
                            {FormattedColumn('Organic Description', 'Organic_description', (displayedState['description'] && displayedState['organic']))}
                            {FormattedColumn('Value Description', 'Value_description', (displayedState['description'] && displayedState['value']))}
                            {FormattedColumn('Core Bullets', 'Core_bullets', (displayedState['bullets'] && displayedState['core']))}
                            {FormattedColumn('Premium Bullets', 'Premium_bullets', (displayedState['bullets'] && displayedState['premium']))}
                            {FormattedColumn('Organic Bullets', 'Organic_bullets', (displayedState['bullets'] && displayedState['organic']))}
                            {FormattedColumn('Value Bullets', 'Value_bullets', (displayedState['bullets'] && displayedState['value']))}
                        </DataTable>
                    }
                </div>
                {<ProgressBar
                    color="#8f25cc"
                    className={`mt-3 loading-bar ${isLoading ? 'page-fade-in' : 'page-fade-out'}`}
                    showValue={false}
                    value={value} />}
            </div>
        </div>
    );
}

export default DemoGenerator;
